import React, { useRef } from "react";
import DownloadExcel from "../../Extra/DownloadExcel";
import CASIndentKpi from "./CASIndentKpi";

const CASOtherIndent = ({
  activeHead,
  data,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  statusAction,
  setStatusAction,
}) => {
  const tableRef = useRef();

  const flattenedData = (data || [])
    .filter((f) => f?.hdr_data?.commodity !== "CEMT")
    .map((item) => {
      const hdr = item.hdr_data || {};
      const dtl = item.dtl_data || [];

      const sources = dtl
        .filter((d) => d.pick_drop_flag === "S")
        .map((d) => d.pick_drop_point);
      const destinations = dtl
        .filter((d) => d.pick_drop_flag === "D")
        .map((d) => d.pick_drop_point);

      const sourceStr = sources.length > 0 ? sources.join(" + ") : "-";
      const destStr = destinations.length > 0 ? destinations.join(" + ") : "-";

      let cleanDate = hdr.order_date || "-";
      if (typeof cleanDate === "string" && cleanDate.includes("T")) {
        const rawDate = cleanDate.split("T")[0];
        const [year, month, day] = rawDate.split("-");
        cleanDate = `${day}-${month}-${year}`;
      }
      const cleanTime = hdr.order_time || "";

      return {
        id: hdr.id || "-",
        order_date: cleanDate,
        order_time: cleanTime,
        source_station: sourceStr,
        destination_station: destStr,
        commodity: hdr.commodity || "-",
        wagon_type: hdr.wagon_type || "-",
        wagons: hdr.wagons || "-",
        fcn_no: hdr.fcn_no || "-",
        status: hdr.action || "-",
        restriction_by_name: hdr.restriction_by_name || "-",
        restriction_remark: hdr.restriction_remark || "-",
        remarks: hdr.remarks || "-",
      };
    });

  const commodityOrder = [
    "FG",
    "RICE",
    "FERT",
    "WHEAT",
    "CONT",
    "CLKR",
    "LST",
    "LSST",
    "BAUX",
    "IORE",
    "NCOL",
    "NEUC",
    "NPBC",
    "NPHC",
    "COAL",
    "ASH",
    "F/ASH",
    "PHC",
  ];
  const sortedData = [...flattenedData].sort((a, b) => {
    const indexA = commodityOrder.indexOf(a.commodity);
    const indexB = commodityOrder.indexOf(b.commodity);

    // Items not in the order array go to the end
    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });

  return (
    <div>
      <div className="newUiCardBody my-2 py-3">
        <div className="row g-3 align-items-center">
          <div className="col-md-12">
            <div className="glass-filter-box d-flex gap-3 align-items-center">
              <div className="newUiBody flex-fill">
                <label className="glass-label">Select Indent Status</label>
                <select
                  className="form-select form-select-sm glass-input"
                  value={statusAction}
                  onChange={(e) => setStatusAction(e.target.value)}
                >
                  <option value="pending">Pending</option>
                  <option value="accept">Accepted</option>
                  <option value="reject">Rejected</option>
                  <option value="Placed">Placed</option>
                </select>
              </div>
              <div className="flex-fill">
                <label className="glass-label">From Date</label>
                <input
                  type="date"
                  className="form-control form-control-sm glass-input"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>

              <div className="flex-fill">
                <label className="glass-label">To Date</label>
                <input
                  type="date"
                  className="form-control form-control-sm glass-input"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
            </div>
          </div>

          <CASIndentKpi data={sortedData} />
        </div>

        <div
          className="newUiBody p-0 mt-3 shadow-sm"
          style={{ borderRadius: "10px", overflow: "hidden" }}
        >
          <div
            className="table-responsive p-0 m-0 scrollspy"
            style={{ maxHeight: "60vh", overflow: "auto" }}
          >
            <table
              className="table table-hover m-0"
              ref={tableRef}
              style={{
                whiteSpace: "nowrap",
                borderCollapse: "separate",
                borderSpacing: "0",
                background: "transparent",
              }}
            >
              <thead className="sticky-top" style={{ zIndex: 4 }}>
                <tr
                  className="table-dark text-uppercase"
                  style={{ fontSize: "11px", letterSpacing: "0.5px" }}
                >
                  <th className="py-3 px-3 text-center text-white-50 border-0">
                    #
                  </th>
                  <th
                    className="py-3 px-3 border-0"
                    style={{
                      position: "sticky",
                      left: 0,
                      zIndex: 5,
                      backgroundColor: "#1a272d",
                      borderRight: "1px solid rgba(255,255,255,0.1)",
                      boxShadow: "2px 0 5px rgba(0,0,0,0.3)",
                    }}
                  >
                    Indent ID
                  </th>
                  <th className="py-3 px-3 border-0">ODR Date/Time</th>
                  <th className="py-3 px-3 border-0">Siding</th>
                  <th className="py-3 px-3 border-0">Destination</th>
                  <th className="py-3 px-3 border-0">Commodity</th>
                  <th className="py-3 px-3 border-0">Wagon Type</th>
                  <th className="py-3 px-3 text-center border-0">Wagons</th>
                  <th className="py-3 px-3 border-0">FCN No</th>
                  <th className="py-3 px-3 text-center border-0">Status</th>
                  <th className="py-3 px-3 border-0">Restriction</th>
                  <th className="py-3 px-3 border-0">Restriction Remark</th>
                  <th className="py-3 px-3 border-0">Remarks</th>
                </tr>
              </thead>
              <tbody>
                {sortedData.length === 0 ? (
                  <tr>
                    <td
                      colSpan="13"
                      className="text-center p-5 text-dark fw-bold bg-transparent"
                    >
                      No records found matching the current criteria.
                    </td>
                  </tr>
                ) : (
                  sortedData.map((obj, ind) => {
                    // Dynamic Color Logic for Statuses
                    const statusKey = (obj.status || "").toLowerCase();
                    let statusStyle = {
                      bg: "rgba(255,255,255,0.5)",
                      text: "#374151",
                      border: "rgba(0,0,0,0.1)",
                    };
                    if (statusKey === "pending")
                      statusStyle = {
                        bg: "rgba(253, 230, 138, 0.7)",
                        text: "#b45309",
                        border: "rgba(251, 191, 36, 0.5)",
                      };
                    else if (statusKey === "accept" || statusKey === "placed")
                      statusStyle = {
                        bg: "rgba(187, 247, 208, 0.7)",
                        text: "#15803d",
                        border: "rgba(74, 222, 128, 0.5)",
                      };
                    else if (statusKey === "reject")
                      statusStyle = {
                        bg: "rgba(254, 202, 202, 0.7)",
                        text: "#b91c1c",
                        border: "rgba(248, 113, 113, 0.5)",
                      };
                    else if (statusKey === "dispatch")
                      statusStyle = {
                        bg: "rgba(191, 219, 254, 0.7)",
                        text: "#1d4ed8",
                        border: "rgba(96, 165, 250, 0.5)",
                      };

                    return (
                      <tr
                        key={ind}
                        className="align-middle"
                        style={{ backgroundColor: "transparent" }}
                      >
                        {/* SNO */}
                        <td
                          className="px-3 text-center text-dark fw-bold border-bottom border-light"
                          style={{ fontSize: "12px", opacity: 0.7 }}
                        >
                          {ind + 1}
                        </td>

                        <td
                          className="px-3 fw-bold text-dark border-bottom border-light"
                          style={{
                            position: "sticky",
                            left: 0,
                            zIndex: 2,
                            backgroundColor: "rgba(255, 255, 255, 0.6)",
                            backdropFilter: "blur(12px)",
                            WebkitBackdropFilter: "blur(12px)",
                            borderRight: "1px solid rgba(255,255,255,0.4)",
                            boxShadow: "2px 0 5px rgba(0,0,0,0.05)",
                          }}
                        >
                          {obj.id}
                        </td>
                        {/* Date & Time */}
                        <td
                          className="px-3 border-bottom border-light"
                          style={{ minWidth: "110px" }}
                        >
                          <div className="d-flex flex-column justify-content-center">
                            <span
                              className="text-dark fw-bold"
                              style={{ fontSize: "13px", opacity: 0.8 }}
                            >
                              {obj.order_date}
                            </span>
                            {obj.order_time && (
                              <span
                                className="text-muted fw-semibold"
                                style={{
                                  fontSize: "11px",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                {obj.order_time}
                              </span>
                            )}
                          </div>
                        </td>

                        <td className="px-3 border-bottom border-light">
                          {obj.source_station !== "-" ? (
                            obj.source_station
                              .split(" + ")
                              .map((point, idx, arr) => (
                                <span
                                  key={idx}
                                  className="d-inline-flex align-items-center"
                                >
                                  <span
                                    className="px-2 py-1 rounded fw-bold shadow-sm"
                                    style={{
                                      backgroundColor:
                                        "rgba(255, 237, 213, 0.8)",
                                      color: "#c2410c",
                                      border:
                                        "1px solid rgba(255, 237, 213, 0.5)",
                                      fontSize: "11px",
                                      letterSpacing: "0.5px",
                                    }}
                                  >
                                    {point}
                                  </span>
                                  {idx < arr.length - 1 && (
                                    <span className="mx-1 text-dark fw-bold">
                                      +
                                    </span>
                                  )}
                                </span>
                              ))
                          ) : (
                            <span className="text-dark opacity-50">-</span>
                          )}
                        </td>

                        {/* Destination Station */}
                        <td className="px-3 border-bottom border-light">
                          {obj.destination_station !== "-" ? (
                            obj.destination_station
                              .split(" + ")
                              .map((point, idx, arr) => (
                                <span
                                  key={idx}
                                  className="d-inline-flex align-items-center"
                                >
                                  <span
                                    className="px-2 py-1 rounded fw-bold shadow-sm"
                                    style={{
                                      backgroundColor:
                                        "rgba(224, 242, 254, 0.8)",
                                      color: "#0369a1",
                                      border:
                                        "1px solid rgba(224, 242, 254, 0.5)",
                                      fontSize: "11px",
                                      letterSpacing: "0.5px",
                                    }}
                                  >
                                    {point}
                                  </span>
                                  {idx < arr.length - 1 && (
                                    <span className="mx-1 text-dark fw-bold">
                                      +
                                    </span>
                                  )}
                                </span>
                              ))
                          ) : (
                            <span className="text-dark opacity-50">-</span>
                          )}
                        </td>

                        <td
                          className="px-3 fw-bold text-dark border-bottom border-light"
                          style={{ fontSize: "13px" }}
                        >
                          {obj.commodity}
                        </td>
                        <td
                          className="px-3 text-dark fw-bold border-bottom border-light"
                          style={{ fontSize: "13px", opacity: 0.8 }}
                        >
                          {obj.wagon_type}
                        </td>

                        {/* Wagons */}
                        <td className="px-3 text-center border-bottom border-light">
                          <span
                            className="px-2 py-1 rounded fw-bold shadow-sm"
                            style={{
                              backgroundColor: "rgba(255, 245, 213, 0.8)",
                              color: "#575c02",
                              border: "1px solid rgba(255, 234, 142, 0.5)",
                              fontSize: "12px",
                              letterSpacing: "0.5px",
                            }}
                          >
                            {obj.wagons}
                          </span>
                        </td>

                        <td
                          className="px-3 text-dark fw-bold border-bottom border-light"
                          style={{ fontSize: "13px", opacity: 0.8 }}
                        >
                          {obj.fcn_no}
                        </td>

                        <td className="px-3 text-center border-bottom border-light">
                          <span
                            className="px-2 py-1 rounded-pill fw-bold text-uppercase shadow-sm"
                            style={{
                              backgroundColor: statusStyle.bg,
                              color: statusStyle.text,
                              border: `1px solid ${statusStyle.border}`,
                              fontSize: "10px",
                              letterSpacing: "0.5px",
                            }}
                          >
                            {obj.status}
                          </span>
                        </td>

                        <td
                          className="px-3 text-danger fw-bold border-bottom border-light"
                          style={{ fontSize: "12px" }}
                        >
                          {obj.restriction_by_name || "-"}
                        </td>
                        <td
                          className="px-3 text-dark border-bottom border-light"
                          style={{
                            fontSize: "12px",
                            opacity: 0.8,
                            maxWidth: "150px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {obj.restriction_remark || "-"}
                        </td>
                        <td
                          className="px-3 text-dark border-bottom border-light"
                          style={{
                            fontSize: "12px",
                            opacity: 0.8,
                            maxWidth: "150px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {obj.remarks || "-"}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          {/* Footer Actions */}
          <div
            className="p-2 d-flex justify-content-end border-top border-light"
            style={{ backgroundColor: "rgba(255,255,255,0.1)" }}
          >
            <DownloadExcel
              tableRef={tableRef}
              fileName={`Indent_Full_Extract_${statusAction}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CASOtherIndent;
